import { z } from 'zod';

export const QuestionnaireTypeCodeZod = z.union([
    z.literal('AHCD'),
    z.literal('EP'),
    z.literal('GDPOA'),
    z.literal('GIFT_TRUST'),
    z.literal('HCPOA'),
    z.literal('HIPAA'),
    z.literal('LW'),
    z.literal('SPEC_INSTRUCTIONS'),
    z.literal('TRUST_FUND'),
]);

export type QuestionnaireTypeCode = z.infer<typeof QuestionnaireTypeCodeZod>;
